export default __webpack_public_path__ + "static/media/arrow-next.9a0dd695.svg";